import DashboardLayout from "@/src/components/layout/DashboardLayout";
import { pressReleaseApiService } from "@/src/lib/api-services/pressReleaseApiServices";
import PressReleaseList from "@/src/modules/press/pressReleaseList";

PressRelease.getLayout = (page) => <DashboardLayout>{page}</DashboardLayout>;

function PressRelease({ pressReleaseData }) {
    return (
        <>
            <div className="bg-gray-50">
                <div className="md:py-16 py-8 max-w-6xl mx-auto">
                    <h1 className="md:text-2xl text-lg font-bold pb-4">
                        Press Releases
                    </h1>

                    {pressReleaseData?.length > 0 &&
                        pressReleaseData.map((item, index) => (
                            <PressReleaseList
                                key={index}
                                pressReleaseData={item}
                            />
                        ))}
                </div>
            </div>
        </>
    );
}

export default PressRelease;

export async function getServerSideProps() {
    let pressReleaseData = [];

    try {
        const response = await pressReleaseApiService.PressReleaseList();
        pressReleaseData = response?.data || [];
    } catch (error) {
        console.error("Failed to fetch press releases:", error);
    }

    return {
        props: {
            pressReleaseData,
            data: {
                seoTitle: "Press Releases | House of Diagnostics | HOD",
                seoDescription:
                    "Read the latest news, company updates, press releases and media coverage of HOD.",
                routerPath: "press",
            },
        },
    };
}
